"use client";

import dynamic from "next/dynamic";
import Link from "@/components/link";

import appStoreAnimation from "../resources/lottie/app-store.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export default function AppStore(props) {
  return (
    <Link
      href="https://apps.apple.com/in/app/adda247/id6451410946"
      target="_blank"
      {...props}
    >
      <Lottie
        animationData={appStoreAnimation}
        initialSegment={[0, 90]}
        loop={false}
      />
    </Link>
  );
}
